import React from 'react';
const Icon = () => (React.createElement("svg", { width: "12", height: "2", viewBox: "0 0 12 2", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("rect", { width: "12", height: "2", rx: "1", fill: "white" })));
export default Icon;
